import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Typography,
} from '@mui/material';
import { IResponseCCS0003 } from '../../../../shared/services/types/response';
import moment from 'moment';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { api } from '../../../../shared/services/api';
import { toast } from 'react-toastify';
import { AxiosError, AxiosRequestConfig } from 'axios';
import utc from 'dayjs/plugin/utc'; // <<< importa o plugin
import dayjs from 'dayjs';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { createAccountGroup, createPersonGroup } from './service';
import AccountGroupAccordion from '../accordionGroup';
import PersonGroupForm from '../personGroupForm';
import CloseIcon from '@mui/icons-material/Close';
import Loading from '../../../../components/loading';
import { handleStatus, handleStatusColor } from '../../../../shared/utils';
import ConfirmGenerateResponseModal from '../../../../shared/components/confirmGenerateResponseModal';

dayjs.extend(utc); // <<< registra o plugin no dayjs

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  height: '90%',
  bgcolor: 'background.paper',
  border: '2px solid #cecece',
  borderRadius: 5,
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  overflowY: 'auto', // <- adiciona scroll vertical
};

interface TypeRecord {
  value: string;
  label: string;
}

interface ModalDetailProps {
  ccsId?: IResponseCCS0003 | null;
  closeModal: (shouldReload?: boolean) => void;
  open: boolean;
  reloadData?: () => void;
}

const ModalDetail = ({
  open,
  ccsId,
  closeModal,
  reloadData,
}: ModalDetailProps) => {
  const token = Cookies.get('@token');
  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(5);
  const [generateIsLoading, setGenerateIsLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [ccsValue, setCcsValue] = useState<IResponseCCS0003 | null>(null);
  const [triggerReload, setTriggerReload] = useState(false);
  const [personCreated, setPersonCreated] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const statusToShow = personCreated ? 'PENDING' : ccsValue?.status;

  // const handleChangePage = (_event: unknown, newPage: number) => {
  //   setPage(newPage);
  // };

  useEffect(() => {
    setShowForm(false);
  }, [open]);

  useEffect(() => {
    if (triggerReload) {
      fetchCcsDetails();
      setTriggerReload(false);
    }
  }, [triggerReload]);

  const toggleForm = () => {
    setShowForm((prev) => !prev);
  };

  const fetchCcsDetails = async () => {
    setCcsValue(null);
    if (!ccsId?.id) return;
    setIsLoading(true);
    try {
      const token = Cookies.get('@token');
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      };
      const response = await api.get(
        `/deposit/getAll?account_deposit_id=${ccsId.id}`,
        config,
      );
      setCcsValue({ ...response.data.data[0] });
      console.log('Novo ccsValue:', response.data.data[0]);

      setIsLoading(false);
      setShowForm(false);
    } catch (err) {
      if (err instanceof AxiosError) {
        toast.error(
          err.response?.data?.error || 'Erro ao buscar detalhes do CCS',
        );
        setIsLoading(false);
      } else {
        toast.error('Erro inesperado ao buscar CCS');
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (open) {
      fetchCcsDetails();
    }
  }, [open]);

  const formik = useFormik({
    initialValues: {
      account_situation: '',
      type_bdv: '',
    },
    validationSchema: Yup.object({
      account_situation: Yup.string().required(
        'Situação da conta é obrigatório',
      ),
      type_bdv: Yup.string().required('Tipo BDV é obrigatório'),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      setIsLoading(true);

      const { success, message } = await createAccountGroup(
        ccsValue?.id || '',
        values,
      );

      if (success) {
        toast.success('Grupo conta criado com sucesso');

        // Reload dos dados
        if (typeof reloadData === 'function') {
          await reloadData();
        }
        // Oculta o formulário
        setShowForm(false);

        await fetchCcsDetails(); // atualiza os dados após criar grupo

        // Limpa os campos do form
        formik.resetForm();
      } else {
        toast.error(`Erro ao criar grupo conta: ${message}`);
      }

      setIsLoading(false);
    },
  });

  const situacaoConta: TypeRecord[] = [
    { value: '1', label: '1 - Conta Ativa' },
    { value: '2', label: '2 - Conta Inexistente' },
    { value: '3', label: '3 - Conta Encerrada' },
    { value: '4', label: '4 - Conta Sob Liminar' },
  ];

  const tipoBDV: TypeRecord[] = [
    { value: '1', label: '1 - Conta de Depósito' },
    { value: '2', label: '2 - Conta de Poupança' },
    { value: '3', label: '3 - Conta de Investimento' },
    { value: '4', label: '4 - Outras Aplicações Financeiras' },
    { value: '5', label: '5 - Conta de Não-Residente - CC5' },
    { value: '6', label: '6 - Conta de Pagamento' },
  ];

  const tipoVinculo: TypeRecord[] = [
    { value: '1', label: '1 - Titular' },
    { value: '2', label: '2 - Co-Titular' },
    {
      value: '3',
      label: '3 - Outros (Procurador, Responsável ou Representante)',
    },
  ];

  const tipoPessoa: TypeRecord[] = [
    { value: 'F', label: '1 - Pessoa Física' },
    { value: 'J', label: '2 - Pessoa Jurídica' },
  ];

  const handleOpenConfirmModal = () => {
    setConfirmModalOpen(true);
  };

  const handleCloseConfirmModal = () => {
    setConfirmModalOpen(false);
  };

  const handleConfirmGenerate = async () => {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json',
      },
    };

    setGenerateIsLoading(true);
    try {
      if (!ccsId?.id) {
        toast.error('ID do CCS não encontrado');
        return;
      }

      const response = await api.get(
        `/archive/response-deposit/${ccsId.id}`,
        config,
      );
      if (response.status === 200) {
        const message = response.data?.message || 'Depósito aceito com sucesso';
        toast.success(message);
        // Atualizar status para PENDING
        setCcsValue((prev) => {
          if (prev) {
            return { ...prev, status: 'PENDING' };
          }
          return prev;
        });
        // Recarregar dados após sucesso
        if (typeof reloadData === 'function') {
          setTimeout(() => {
            reloadData();
          }, 1500);
        }
      }
    } catch (err: unknown) {
      if (err instanceof AxiosError) {
        const errorMessage = err.response?.data?.message || err.response?.data?.error || 'Erro de conexão';
        toast.error(errorMessage);
      } else {
        toast.error('Erro inesperado');
      }
    } finally {
      setGenerateIsLoading(false);
      setConfirmModalOpen(false);
    }
  };

  const handleClose = (shouldReload?: boolean) => {
    setPersonCreated(false); // reseta
    closeModal(shouldReload);
  };

  return (
    <Modal
      open={open}
      onClose={() => handleClose(true)}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box sx={{ ...style }}>
        <Loading isLoading={isLoading} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <Typography variant="h5">Detalhes do Arquivo CCS0003:</Typography>

            <Typography ml={1} color="primary.main" variant="h6">
              {ccsValue?.number_control_ccs}
            </Typography>
          </Box>
          <Button onClick={() => handleClose(true)}>
            <CloseIcon />
          </Button>
        </Box>
        <Typography variant="body1">
          Data de envio Bacen:{' '}
          {moment(ccsValue?.date_time_bacen).format('DD/MM/yyyy')}
        </Typography>
        <Box mt={2}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}
          >
            <Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'start',
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                {ccsValue?.account_deposit_number && (
                  <Box display="flex" alignItems="baseline" mb={1}>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      mr={1}
                      sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
                    >
                      Número de Depósito da Conta:
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                    >
                      {ccsValue?.account_deposit_number}
                    </Typography>
                  </Box>
                )}
                {ccsValue?.movement_date && (
                  <Box display="flex" alignItems="baseline" mb={1}>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      mr={1}
                      sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
                    >
                      Data de Movimento:
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                    >
                      {dayjs.utc(ccsValue?.movement_date).format('DD/MM/YYYY')}
                    </Typography>
                  </Box>
                )}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'start',
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                {ccsValue?.start_date && (
                  <Box display="flex" alignItems="baseline">
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      mr={1}
                      sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
                    >
                      Data Início:
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                    >
                      {dayjs.utc(ccsValue?.start_date).format('DD/MM/YYYY')}
                    </Typography>
                  </Box>
                )}
                {ccsValue?.end_date && (
                  <Box display="flex" alignItems="baseline">
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      mr={1}
                      sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
                    >
                      Data Fim:
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}
                    >
                      {dayjs.utc(ccsValue?.end_date).format('DD/MM/YYYY')}
                    </Typography>
                  </Box>
                )}
                {statusToShow && (
                  <Typography>
                    <Box
                      component="span"
                      sx={{
                        display: 'inline-block',
                        px: 1.5,
                        py: 0.2,
                        borderRadius: 10,
                        fontSize: 12,
                        bgcolor: handleStatusColor(statusToShow),
                        color: 'white',
                      }}
                    >
                      {handleStatus(statusToShow)}
                    </Box>
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
          {ccsValue?.status !== 'DONE' && (
            <Button
              variant="contained"
              onClick={toggleForm}
              sx={{ mb: 2, mt: 2 }}
              size="large"
            >
              {showForm ? 'Ocultar Formulário' : 'Adicionar Novo Grupo Conta'}
            </Button>
          )}
          {showForm && (
            <>
              <Typography variant="h6">Novo Grupo Conta</Typography>
              <Box
                component="form"
                onSubmit={formik.handleSubmit}
                sx={{ marginBottom: 4 }}
              >
                <Box display="flex" flexDirection="column" gap={2}>
                  <FormControl
                    fullWidth
                    error={
                      formik.touched.account_situation &&
                      Boolean(formik.errors.account_situation)
                    }
                  >
                    <InputLabel id="account-situation-label">
                      Situação da Conta
                    </InputLabel>
                    <Select
                      labelId="account-situation-label"
                      id="account_situation"
                      name="account_situation"
                      value={formik.values.account_situation}
                      label="Situação da Conta"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      {situacaoConta.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>
                      {formik.touched.account_situation &&
                        formik.errors.account_situation}
                    </FormHelperText>
                  </FormControl>
                  <FormControl
                    fullWidth
                    error={
                      formik.touched.type_bdv && Boolean(formik.errors.type_bdv)
                    }
                  >
                    <InputLabel id="type-bdv-label">Tipo BDV</InputLabel>
                    <Select
                      labelId="type-bdv-label"
                      id="type_bdv"
                      name="type_bdv"
                      value={formik.values.type_bdv}
                      label="Tipo BDV"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      {tipoBDV.map((item) => (
                        <MenuItem key={item.value} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>
                      {formik.touched.type_bdv && formik.errors.type_bdv}
                    </FormHelperText>
                  </FormControl>

                  <Box display="flex" justifyContent="flex-end">
                    <Button
                      type="button"
                      variant="contained"
                      color="primary"
                      disabled={isLoading}
                      onClick={() => formik.handleSubmit()}
                    >
                      {isLoading ? 'Salvando...' : 'Salvar'}
                    </Button>
                  </Box>
                </Box>
              </Box>
            </>
          )}
          <AccountGroupAccordion
            fetchCcsDetails={fetchCcsDetails}
            status={ccsValue?.status}
            accountGroups={ccsValue?.account_groups}
            childrenRenderer={(group) => (
              <PersonGroupForm
                group={group}
                tipoPessoa={tipoPessoa}
                tipoVinculo={tipoVinculo}
                createPersonGroup={createPersonGroup}
                triggerReload={() => setTriggerReload(true)}
                onPersonCreated={() => setPersonCreated(true)}
              />
            )}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            mt: 5,
          }}
        >
          {ccsValue?.status === 'AWAITING_MANUAL_ACCEPTANCE' && (
            <Button
              variant="contained"
              color="primary"
              disabled={generateIsLoading}
              onClick={handleOpenConfirmModal}
            >
              Aceitar e Enviar
            </Button>
          )}
          {ccsValue?.status === 'PENDING' && (
            <Typography variant="body2" color="info.main" sx={{ fontStyle: 'italic' }}>
              Enviando ao BACEN...
            </Typography>
          )}
          <ConfirmGenerateResponseModal
            open={confirmModalOpen}
            isLoading={generateIsLoading}
            onConfirm={handleConfirmGenerate}
            onCancel={handleCloseConfirmModal}
            actionType="accept"
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalDetail;
